import { LAST_ATTRIBUTED_TOUCH_DATA_TILDE_CAMPAIGN_NAME } from '../../../../../../../shared/constants/cenariusDimensions';
import { ALL_EVENT_NAMES, CORE_EVENT_NAMES } from '../../../../../common/support/eo_mapping';
import { CHARTS_DEFAULT_HIGH_CHART_CONFIG } from '../../../../constants';

export const EVENT_LIST = Object.keys(ALL_EVENT_NAMES).filter((e) => e !== 'IMPRESSION' && e !== 'PAGEVIEW' && e !== 'cost');

export const DEFAULT_DATA_SOURCES = [CORE_EVENT_NAMES.INSTALL];

export const MIN_DIMENSIONS = 0;

export const MAX_DIMENSIONS = 1;

export const DEFAULT_DIMENSIONS = [LAST_ATTRIBUTED_TOUCH_DATA_TILDE_CAMPAIGN_NAME];

function handleLegendItemClick(this: Highcharts.Series) {
  if (!this.visible) {
    this.setVisible(true);
    return;
  }

  const visibleSeries = this.chart.series.filter((serie) => serie.visible);
  if (visibleSeries.length === this.chart.series.length) {
    this.chart.series.forEach((serie) => {
      if (serie.index !== this.index) {
        serie.setVisible(false);
      }
    });
    return;
  }

  if (visibleSeries.length === 1) {
    this.chart.series.forEach((serie) => {
      serie.setVisible(true);
    });
    return;
  }

  this.setVisible(false);
}

export const JOURNEYS_HIGH_CHART_CONFIG = {
  ...CHARTS_DEFAULT_HIGH_CHART_CONFIG,
  exporting: {
    filename: 'journeys',
    chartOptions: {
      title: {
        text: 'Journeys',
      },
    },
  },
  plotOptions: {
    ...CHARTS_DEFAULT_HIGH_CHART_CONFIG.plotOptions,
    series: {
      ...CHARTS_DEFAULT_HIGH_CHART_CONFIG.plotOptions.series,
      events: {
        legendItemClick: function (e) {
          e.preventDefault();
          handleLegendItemClick.call(this);
        },
      },
    },
  },
};
